import { Capacitor } from "@capacitor/core";

export function isCapacitorPlatform(): boolean {
  return Capacitor.isNativePlatform();
}

export function isAndroidPlatform(): boolean {
  return Capacitor.getPlatform() === "android";
}

export function isIosPlatform(): boolean {
  return Capacitor.getPlatform() === "ios";
}
